import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Assumptions } from '../static/Assumptions';
import { Package } from './Package';
import { Product } from '../static/Product';

@supertypeClass({ toClient: ['admin'], toServer: true })
export class PackageQuery extends Everything {
  @property()
  carrier: string = 'HAVE';

  @property({
    values: function () {
      const values = {};

      for (const p in Product.products) {
        values[p] = Product.products[p].name;
      }

      return values;
    },
  })
  product: string;

  @property({ values: Assumptions.stateValues })
  state: string;

  @property()
  inProduction: boolean;

  @property({ isLocal: true })
  removeThisReferenceNeededToKeepSingleFileTemplateHappy: Package;

  constructor() {
    super();
  }

  static new() {
    return new PackageQuery().init();
  }

  init() {
    return this;
  }
}
